import Rellax from 'rellax';
document.addEventListener('DOMContentLoaded', function() {
    const rellax = new Rellax('.rellax');
});
  

import 'animate.css';

import WOW from 'wow.js';

export default class WowInitializer {
    constructor() {
        this.setOffsets();
        this.initWOW();
    }

    setOffsets() {
        const animatedElements = document.querySelectorAll('.animate__animated');
        const screenWidth = window.innerWidth;

        const isSmallScreen = screenWidth <= 1280;
        const baseOffset = isSmallScreen ? -100 : 50;

        animatedElements.forEach((el, index) => {
            let offset;
            if (isSmallScreen) {
                offset = baseOffset - (index * 150);
            } else {
                offset = baseOffset + (index * 10);
            }

            el.classList.add('wow'); 
            el.setAttribute('data-wow-offset', offset);
        });
    }

    initWOW() {
        const wow = new WOW({
            boxClass: 'wow',
            animateClass: 'animate__animated',
            offset: 0,
            mobile: true,
            live: true,
            scrollContainer: null,
        });

        wow.init();

        window.addEventListener('load', () => {
            setTimeout(() => {
                wow.sync();
            }, 500);
        });
    }
}

new WowInitializer();

require('./selection/modal.js');
require('./selection/slider-product.js');
require('./selection/slider-recipe.js');
require('./selection/copy-link.js');